// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_2k9Nr7IaxqE3ZfQoxDtlma","body":"_1bBSX0J_Qi2hmz9i-DbbFS","header":"_3KqdBsZE7tJWWKWQOIOxV","title":"_2WJaxdXLjCW7610KIAxYnl","subTitle":"_1_GY_6V2na3wRHQe-C9P9F"};